module.exports = __webpack_public_path__ + "static/media/galerija_2013 (29).b28486ae.jpg";